import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { loadLanguage, saveLanguage } from './storage';
import { languages } from './constants';

import moment from 'moment';

const language = loadLanguage();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    // lng: languages.includes(language) ? language : 'hu',
    // fallbackLng: 'hu',
    lng: languages.includes(language) ? language : 'en',
    fallbackLng: 'en',
    supportedLngs: languages,
    load: 'currentOnly',
    ns: 'common',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    returnEmptyString: false,
  });

i18n.on('languageChanged', (lng) => {
  if (languages.includes(lng)) {
    moment.locale(lng);
    saveLanguage(lng);
  }
});

export default i18n;
